import { Navigate } from "react-router-dom";
import { useAuthState } from "@/hooks/useAuthState";
import { useMonitorRedirect } from "@/hooks/useMonitorRedirect";
import { LoadingState } from "./LoadingState";

export const MonitorRoute = ({ children }: { children: React.ReactNode }) => {
  const { isAuthenticated, loading } = useAuthState();
  const { isMonitor, isCheckingRole } = useMonitorRedirect();

  if (loading || isCheckingRole) {
    return <LoadingState />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/intro" replace />;
  }

  if (!isMonitor) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};
